/**
 * Import da biblioteca "styled-components", que permite escrever 
 * CSS simples para os componentes sem acontecer conflitos com os 
 * nomes das clases, são escritos entre Tagged Templates Literals(``).
 */
import styled from 'styled-components';

/**
 * Estilização do componente Wrap
 */
export const Wrap = styled.div`
  @keyframes fadeIn {
    from {
      height: 0;
    }
    to {
      height: 50%;
    }
  }
  .bottom-panel {
    animation-name: fadeIn;
    animation-duration: 300ms;
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 1500;
    width: 100%;
    height: ${({ expandLevel }) =>
      expandLevel === 1 ? '30%' : expandLevel === 2 ? '50%' : '100%'};
    padding: 20px 0 0 37px;
    transition: height 300ms;
    .button {
      position: absolute;
      color: #bababa;
      background: transparent;
      border: none;
      margin: 0;
      padding: 0;
      transition: transform 300ms;
      &.left-arrow {
        transform: ${({ expandLeft }) =>
          expandLeft ? 'rotate(90deg)' : 'rotate(-90deg)'};
        left: 0;
        top: 30px;
      }
      &.top-arrow-up {
        top: 5px;
        left: calc(50% - 35px);
      }
      &.top-arrow-down {
        top: 5px;
        left: calc(50% - 0px);
        transform: rotate(180deg);
      }
      &.close {
        right: 10px;
        top: 7px;
        svg {
          width: 20px;
          height: 20px;
        }
      }
      &:hover {
        color: #3c71dd;
      }
    }
    @media (max-width: 768px) {
      display: none;
    }
  }
`;
